import React from "react";
import packageJson from "../../../package.json";

const VersionText = () => {
    return <p>WealthPro Version: {packageJson.version}</p>
};

export default VersionText;